import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '../Rebass';
import styles from './styles';
import { autoprefix } from '../../utils/helpers';

export interface UIComponent {
  displayName?: string;
}

export interface ContainerProps {
  sx?: object;
  children?: React.ReactNode;
}

export interface GridContainerProps {
  sx?: object;
  children?: React.ReactNode;
}

const Container: FC<ContainerProps> & UIComponent = (props) => {
  const { base } = styles;
  const { sx } = props;
  return <Box {...props} sx={{ ...base, ...sx }} />;
};

const WideContainer: FC<ContainerProps> & UIComponent = (props) => {
  const { wide } = styles;
  const { sx } = props;
  return <Container {...props} sx={{ ...wide, ...sx }} />;
};

const TallContainer: FC<ContainerProps> & UIComponent = (props) => {
  const { tall } = styles;
  const { sx } = props;
  return <Container {...props} sx={{ ...tall, ...sx }} />;
};

const Grid = styled(Box)`
  display: grid;
  display: -ms-grid;
  ${({ sx }) => autoprefix(sx)}
`;
const GridContainer: FC<GridContainerProps> & UIComponent = (props) => {
  const { base, grid } = styles;
  const { sx } = props;
  return <Grid {...props} sx={{ ...base, ...grid, ...sx }} />;
};

const GridCell = styled(Box)`
  -ms-grid-column: ${({ index, cols }) => (index % cols) + 1};
  -ms-grid-row: ${({ index, cols }) => Math.floor(index / cols) + 1};
`;

Container.displayName = 'Container';
GridContainer.displayName = 'GridContainer';
TallContainer.displayName = 'TallContainer';
WideContainer.displayName = 'WideContainer';

export { Container, GridContainer, TallContainer, WideContainer, GridCell };
